<template>
  <div
    class="box-count-down"
    :class="{ 'box-count-down-light': theme === 'light' }"
  >
    <div class="box">{{ Math.floor(hour / 10) }}</div>
    <div class="box">{{ hour % 10 }}</div>
    <div>:</div>
    <div class="box">{{ Math.floor(minute / 10) }}</div>
    <div class="box">{{ minute % 10 }}</div>
    <div>:</div>
    <div class="box">{{ Math.floor(second / 10) }}</div>
    <div class="box">{{ second % 10 }}</div>
  </div>
</template>

<script>
/**
 * 数字框的倒计时组件
 */
export default {
  name: 'BoxCountDown',

  props: {
    leftTime: {
      type: Number,
      required: true
    },

    theme: {
      validator: function(value) {
        return ['dark', 'light'].indexOf(value) !== -1
      },
      default: 'dark'
    }
  },

  computed: {
    second() {
      return (this.leftTime / 1000) % 60
    },
    minute() {
      return Math.floor(this.leftTime / 1000 / 60) % 60
    },
    hour() {
      return Math.floor(this.leftTime / 1000 / 60 / 60)
    }
  }
}
</script>

<style lang="scss" scoped>
.box-count-down {
  display: flex;
  align-items: center;
  font-size: 48px;
  color: $white-color;

  &.box-count-down-light {
    color: $third-text-color;

    .box {
      background: linear-gradient(0deg, #1890ff, #30ceff) !important;
      border: none;
      color: $white-color;
    }
  }

  .box {
    flex: 1;
    height: 76px;
    border: 2px solid;
    background: rgba(0, 53, 178, 0.3);
    border-image: linear-gradient(0deg, #24c4ff, #0057c2) 10 10;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div {
    & + div {
      margin-left: 16px;
    }
  }
}
</style>
